<template>
  <div>
    <b-overlay :show="isLoading" rounded="sm" spinner-variant="primary" spinner-type="grow">
      <b-row style="margin: 5px;">
        <label style="font-weight: bold;">Survey Default Questions Settings:</label>
      </b-row>

      <!-- Main Survey List -->
      <div v-if="currentSurveyIndex === null">
        <b-card v-for="(survey, sIndex) in surveys" :key="sIndex" class="mb-3 border-info">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <h5 class="text-primary mb-0">{{ survey.name }}</h5>
            <b-button variant="primary" size="sm" @click="openSurveyEditorInNewTab(sIndex)">
              Add / Edit Questions
            </b-button>
          </div>

          <div class="mb-2">
            <b-form-checkbox v-model="survey.set_as_default" @change="setUserGroupsSurveyDefaultQuestions">
              Set the added question as default for the above survey
            </b-form-checkbox>
          </div>
        </b-card>
      </div>
    </b-overlay>
  </div>
</template>

<script>
export default {
  data() {
    return {
      surveys: [
        { name: "Instructor Feedback Survey", key: "student_feedback", set_as_default: false, questions: [] },
        { name: "HOD Feedback Survey", key: "hod_feedback", set_as_default: false, questions: [] },
        { name: "Class Advisors Feedback Survey", key: "class_advisors_feedback", set_as_default: false, questions: [] },
        { name: "Infrastructure Feedback Survey", key: "infrastructure_feedback", set_as_default: false, questions: [] },
      ],
      courseOutcomesOptions: [],
      poOptions: [],
      psoOptions: [],
      currentSurveyIndex: null,
      isLoading: false, //  loader state
    };
  },
  async created() {
    this.isLoading = true;
    try {
      await this.getAllSurveyDefaultQuestions();
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    openSurveyEditorInNewTab(sIndex) {
      const routeData = this.$router.resolve({
        path: `/institution_config_survey_questions/${sIndex}`,
      });
      window.open(routeData.href, "_blank");
    },
    async setUserGroupsSurveyDefaultQuestions() {
      this.isLoading = true;
      try {
        const settingKey = "survey_default_questions";
        let mainUrl = this.$store.getters.getAPIKey.institutionSettings;
        const url = mainUrl.replace("setting_key", settingKey);

        // Fetch latest data before saving
        const fetchResponse = await this.$axios.get(url);
        const latestData = fetchResponse.data || {};

        // Update local surveys with latest questions
        this.surveys.forEach((survey) => {
          const existing = latestData[survey.key]?.questions;
          if (Array.isArray(existing)) {
            survey.questions = existing.map((q, i) => ({
              question_no: q.question_no ?? i + 1,
              name: q.name ?? "",
              allow_descriptive: q.allow_descriptive ?? false,
              answer_required: q.answer_required ?? false,
              choices: q.choices ?? [],
              course_outcomes: q.course_outcomes ?? [],
              programme_outcomes: q.programme_outcomes ?? [],
              programme_specificoutcomes: q.programme_specificoutcomes ?? [],
              editMode: false,
            }));
          }
        });

        // Prepare data for saving
        const surveyData = {};
        this.surveys.forEach((survey) => {
          surveyData[survey.key] = {
            set_as_default: survey.set_as_default,
            questions: survey.questions,
          };
        });

        // Save updated settings
        await this.$axios.post(url, { survey_default_questions: surveyData });

        this.$toast.success("Updated successfully!", {
          position: "top",
          duration: 3000,
        });
      } catch (error) {
        console.error(error);
        this.$toast.error("Error updating survey settings.", {
          position: "top",
          duration: 3000,
        });
      } finally {
        this.isLoading = false;
      }
    },

    async getAllSurveyDefaultQuestions() {
      const settingKey = "survey_default_questions";
      let mainUrl = this.$store.getters.getAPIKey.institutionSettings;
      const url = mainUrl.replace("setting_key", settingKey);

      try {
        const response = await this.$axios.get(url);
        const data = response.data || {};
        this.surveys.forEach((survey) => {
          const existing = data[survey.key]?.questions;
          if (Array.isArray(existing)) {
            survey.questions = existing.map((q, i) => ({
              question_no: q.question_no ?? i + 1,
              name: q.name ?? "",
              allow_descriptive: q.allow_descriptive ?? false,
              answer_required: q.answer_required ?? false,
              choices: q.choices ?? [],
              course_outcomes: q.course_outcomes ?? [],
              programme_outcomes: q.programme_outcomes ?? [],
              programme_specificoutcomes: q.programme_specificoutcomes ?? [],
              editMode: false,
            }));
          }
          survey.set_as_default = data[survey.key]?.set_as_default ?? false;
        });
      } catch (error) {
        console.error(error);
      }
    },

  },
};
</script>
